import { createSlice } from '@reduxjs/toolkit';
import { fetchEnquiries } from './enquiryThunk';

const INITIAL_STATE = {
  name: 'enquiries',
  enquiries: [],
  isLoading: false,
  error: null
};

const enquirySlice = createSlice({
  name: 'enquiries',
  initialState: INITIAL_STATE,
  extraReducers: (builder) => {
    builder

    .addCase(fetchEnquiries.fulfilled, (state, action) => {
        state.isLoading = false;
        state.enquiries = action.payload?.data || [];
      })

      // Pending Matcher
      .addMatcher(
        (action) => action.type.startsWith('customerContact/') && action.type.endsWith('/pending'),
        (state) => {
          state.isLoading = true;
          state.status = API_STATUS_TYPE.PENDING;
          state.error = null;
        }
      )

      // Rejected Matcher
      .addMatcher(
        (action) => action.type.startsWith('customerContact/') && action.type.endsWith('/rejected'),
        (state, action) => {
          state.isLoading = false;
          state.status = API_STATUS_TYPE.FAILED;
          state.error = action.payload || 'An unexpected error occurred';
        }
      );
  }
});

export const { fetchEnquiriesFailure } = enquirySlice.actions;

export default enquirySlice.reducer;
